



































































import { Component, Prop, Vue } from 'vue-property-decorator'

@Component
export default class TranslationIcon extends Vue {
  @Prop({ default: false }) disabled!: boolean
  onTranslate() {
    if (!this.disabled) {
      this.$emit('translate')
    }
  }
}
